import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { useAppDispatch } from "../../utils/hooks";
import { StoryListRes } from "../../types/StatusTypes";
import { updateStoryListRes } from "../Slices/StatusSlice";

export const useStatusList = (options?: { enabled?: boolean }) => {
  const dispatch = useAppDispatch();

  return useQuery<StoryListRes, Error>(
    ["/story/get-stories"],
    async () => {
      const response = await axiosInstance.get<StoryListRes>("story/get-stories");
      dispatch(updateStoryListRes(response.data));
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: options?.enabled ?? true,
    },
  );
};
